<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <g class="float">
      <!-- Central chat/message card -->
      <rect
        x="55"
        y="35"
        width="90"
        height="80"
        rx="10"
        fill="#f5f3ff"
        stroke="#a78bfa"
        stroke-width="1"
      />

      <!-- Message rows with user avatars -->
      <circle cx="75" cy="55" r="8" fill="#ddd6fe" />
      <circle cx="75" cy="55" r="4" fill="#a78bfa" />
      <rect x="90" y="50" width="40" height="5" rx="2" fill="#c4b5fd" />
      <rect x="90" y="58" width="28" height="4" rx="2" fill="#e9d5ff" />

      <circle cx="75" cy="80" r="8" fill="#ede9fe" />
      <circle cx="75" cy="80" r="4" fill="#7c3aed" />
      <rect x="90" y="75" width="35" height="5" rx="2" fill="#c4b5fd" />
      <rect x="90" y="83" width="42" height="4" rx="2" fill="#e9d5ff" />

      <!-- Notification indicator -->
      <circle cx="135" cy="45" r="8" fill="#7c3aed" class="pulse" />
      <text
        x="135"
        y="48"
        text-anchor="middle"
        fill="white"
        font-size="9"
        font-weight="bold"
      >
        2
      </text>
    </g>
  </svg>
</template>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
.float {
  animation: float 4s ease-in-out infinite;
}
.pulse {
  animation: pulse 2s ease-in-out infinite;
}
</style>
